import React from 'react';

import './About.css'

const About = () => {
    return (
        <div className='about-bg'>
            {/* about item */}
            
          <div className='cards'>
    
    <div className='row  p-5 bg-info text-justify '>
    <div className="col-md-6  p-2 text-light">
        <h3>General and acute care  </h3>
        <p>A teaching hospital combines assistance to people with teaching to medical students and nurses. A medical facility smaller than a hospital is generally called a clinic </p>
    </div>
    <div className="col-md-6 p-2 text-light">
        <h3>District </h3>
        <p> hospital is a health care institution providing patient treatment with specialized medical and nursing staff and medical equipment.[1] The best-known type of hospital is the general hospital, which typically has  </p>
    </div>
    
    
</div>
          </div>
            
        </div>
    );
};

export default About;